
<template>
  <div style="display:flex">
    <div class="box" style="width:100%">
      <div class="boxTitle" style="margin:15px">Top10贸易额关口</div>
      <div class="echart" style="">
        <dv-capsule-chart :config="config2" style="width:100%;height:300px" />
      </div>
    </div>
  </div>

</template>

<script>
	export default {
		name: "eight",
		data() {
      return {
        config2:{
          data: [
            {
              name: '银川海关',
              value: 3848858.1300
            },
            {
              name: '乌鲁木齐海关',
              value: 3148858.1300
            },
            {
              name: '满洲里海关',
              value: 2948858.1300
            },
            {
              name: '兰州海关',
              value: 2748858.1300
            },
            {
              name: '天津海关',
              value: 2548858.1300
            },
            {
              name: '南京海关',
              value: 2448858.1300
            },
            {
              name: '宁波海关',
              value: 2048858.1300
            },
            {
              name: '深圳海关',
              value: 1048858.1300
            },
            {
              name: '汕头海关',
              value: 848858.1300
            },
          ],
          showValue: true,
          unit: '人民币',
        }

      }
		},
    mounted() {

    },
    methods:{
      datainfo() {

      },
    }
	}

</script>

<style>
  .echart{
    display:flex;
    justify-content:center;
  }
  .box{
    position:relative;
  }
  .miniTitle{
    font-size:15px;
    color:#fff;
    display:flex;
    width:100%;
    position:absolute;
    top:65px;
  }
  .miniTitle span{
    width:50%;
    padding-left:15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/right/eight.vue